// extracted by mini-css-extract-plugin
module.exports = {"MotorDataPhaseItem":"MotorDataPhaseItem__MotorDataPhaseItem___2Z3H3","Green":"MotorDataPhaseItem__Green___1qpBg","Orange":"MotorDataPhaseItem__Orange___17o3L"};